module.exports = __webpack_public_path__ + "img/appstore-2-x-8.bf9f56fe.png";